import { Container } from '../ui'

export function Details() {
  return (
    <section
      id="details"
      className="relative overflow-hidden py-20 sm:py-32 w-full"
      style={{
        backgroundImage: 'url(/background-features.jpg)',
        backgroundSize: '100% 100%',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className="absolute inset-0" style={{ backgroundColor: 'var(--color-brand-primary)' }} />
      <Container className="relative">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-display text-3xl tracking-tight sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-12" style={{ color: 'var(--color-text-inverse)' }}>
            Introducing Simple CPRs
          </h2>
          <div className="space-y-6 text-lg sm:text-xl lg:text-2xl tracking-wide leading-relaxed" style={{ color: 'var(--color-text-inverse)' }}>
            <p className="max-w-3xl mx-auto">
              You found yourself here because you're staring at a confusing PDF. Whether it's the federal DOL WH-347 or a state form, you're looking for a better way to get it done.
            </p>
            <p className="max-w-3xl mx-auto font-medium">
              Our simple, wizard-driven tool walks you through every field, ensuring you produce a perfect, audit-ready report without the headaches. It's that simple.
            </p>
          </div>
        </div>
      </Container>
    </section>
  )
} 